import('./pb-findstore--static.css');

const pbFindStoreStatic = {
    init: function () {
        // Leva para mapa
        /*
        $('.pb-findstore--static #searchStore').on('click', function(e) {
            e.preventDefault();
            var place = $('input[name="where"]:checked').val();
            var url = $('#findstorefield').data('url');
            var salesChannel = $('#findstorefield').data('saleschannel');
            window.location.href = url + '?place=' + place + '&sales_channel=' + salesChannel;
            return false;
        });;
        $('.pb-findstore--static #getLocation').on('click', function(e) {
            e.preventDefault();
            var place = $('input[name="where"]:checked').val();
            var url = $('#findstorefield').data('url');
            var salesChannel = $('#findstorefield').data('saleschannel');
            window.location.href = url + '?getLocation=true&sales_channel=' + salesChannel;
            return false;
        });
        */

        //Get element of <p> tag before radio whereFilter input and hide
        var paragraphTag = $("#find-p-tag");
        paragraphTag.hide();

        //Get element of whereFilter and hide
        var searchFilterWhereElement = $(".locale .form-check");
        searchFilterWhereElement.hide();

        //Get element of channelFilter and hide
        var searchChannelFiltersElement = $('#search-filters');
        searchChannelFiltersElement.hide();

        $('form#searchStore').on('submit', function(e){
            e.preventDefault();
            e.stopPropagation(e);
            if(salesChannel == 'portobello-shop'){
                var action = 'onde-comprar-shop';
            } else {
                var action = 'onde-comprar';
            }
            
            var query = $(this).find('#findstorefield').val();
            var path = action+'?q='+query+'&sales_channel='+salesChannel;

            window.location.href = path;
            return false;
        });

        $('form#searchStore div.filtersChannel input.form-check-input').on('change', function(e)
        {
            // console.log($(this).val());
            // console.log($(this).attr('checked'));
        });
    }
}
// initialize component
window.loadedComponents.push({ component: 'pb-findstore--static', init: pbFindStoreStatic.init});

export default() => {
    pbFindStoreStatic.init();
}